import { render, staticRenderFns } from "./noc.vue?vue&type=template&id=03aa656a&"
import script from "./noc.vue?vue&type=script&lang=js&"
export * from "./noc.vue?vue&type=script&lang=js&"
import style0 from "./noc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports